/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatchApiKeyRequestApiKey } from './PatchApiKeyRequestApiKey';
import {
    PatchApiKeyRequestApiKeyFromJSON,
    PatchApiKeyRequestApiKeyFromJSONTyped,
    PatchApiKeyRequestApiKeyToJSON,
} from './PatchApiKeyRequestApiKey';

/**
 * 
 * @export
 * @interface PatchApiKeyRequest
 */
export interface PatchApiKeyRequest {
    /**
     * Array of field paths specifying which fields to update. Allowed values include:
     * - active
     * - label
     * - scopes
     * @type {Array<string>}
     * @memberof PatchApiKeyRequest
     */
    updateMask: Array<string>;
    /**
     * 
     * @type {PatchApiKeyRequestApiKey}
     * @memberof PatchApiKeyRequest
     */
    apiKey: PatchApiKeyRequestApiKey;
}

/**
 * Check if a given object implements the PatchApiKeyRequest interface.
 */
export function instanceOfPatchApiKeyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updateMask" in value;
    isInstance = isInstance && "apiKey" in value;

    return isInstance;
}

export function PatchApiKeyRequestFromJSON(json: any): PatchApiKeyRequest {
    return PatchApiKeyRequestFromJSONTyped(json, false);
}

export function PatchApiKeyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchApiKeyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateMask': json['updateMask'],
        'apiKey': PatchApiKeyRequestApiKeyFromJSON(json['apiKey']),
    };
}

export function PatchApiKeyRequestToJSON(value?: PatchApiKeyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateMask': value.updateMask,
        'apiKey': PatchApiKeyRequestApiKeyToJSON(value.apiKey),
    };
}

